// extracted by mini-css-extract-plugin
export default {"quill":"Quill_quill__5AbMA","no_border":"Quill_no_border__7DmUG"};